import { AppState } from '@Redux/store';
import { ArmyBook } from '@Models';

export const getArmyBooksSelector = (state: AppState): Array<ArmyBook> => {
  return state.armyBooks.entity ?? [];
};
